import React, {useEffect, useState} from 'react';
import {PickList as PPickList} from 'primereact/picklist';
import {Inplace, InplaceDisplay, InplaceContent} from 'primereact/inplace';
import { Button } from 'primereact/button'
import {extract, fieldValAsString, wrapArray} from "../utils";
import _ from 'lodash';
import {InputText} from "primereact/inputtext";
import InplaceCustomOption from "./InplaceCustomOption";
import {v4 as uuid} from 'uuid';

const PickList  = ({onChange, value, choices, choiceValueKey = 'name', choiceLabelKey = 'name', extraConfig, ...rest}) => {
    const [sourceSearch, setSourceSearch] = useState('')
    const [targetSearch, setTargetSearch] = useState('')
    const [source,setSource] = useState([])
    const [target, setTarget] = useState( [] )
    const {sourceLabel, targetLabel, searchSource = true, searchTarget = true, height} = extraConfig
    useEffect(() => {
        const s = []
        const t = []
        const existing = wrapArray(value)
        console.log('Mapping PickList', existing, choices)
        choices?.forEach( c => {
            let has = existing.find( e => e[choiceValueKey] === c[choiceValueKey] )
            if(has)t.push(c)
            else s.push(c)
        })
        setSource( s )
        setTarget( t )
    }, [choices.map( c => c[choiceValueKey] ).join(",")])
    const itemTemplate = (item) => _.isObject(item as any) ? item[choiceLabelKey] : item
    // const onMove = ( dest, items ) => {
    //     console.log('PickList On Move', dest, items, source, target, choiceValueKey)
    //     const filt = ( which ) => which.filter( s => !items.map( i => i[choiceValueKey]).includes(s[choiceValueKey]) )
    //     setSource( dest === 'target' ? filt( source ) : source.concat(items) )
    //     const newTarget = dest === 'source' ? filt( target ) : target.concat(items)
    //     console.log('PickList On Move', dest, items, newTarget)
    //     setTarget( newTarget )
    //     onChange(newTarget.map( c => c[choiceValueKey]) )
    // }
    // const onSort = (e) => e.source.length === source.length ? setTarget(e.target) : null
    const onChangePick = (e) => {
        setSource( e.source )
        setTarget( e.target )
    }

    const filter = (items, location) => {
        return items.map( i => ({...i, filter_label:fieldValAsString(i[choiceLabelKey]) }))
        // let search = location === 'source' ? sourceSearch : targetSearch
        // if(!search)return items
        // search = search.toLowerCase()
        //
        // return items.filter( i => fieldValAsString(i[choiceLabelKey]).toLowerCase().includes(search) )
    }

    const useHeaderHeight = searchSource || searchTarget ? '75px' : '10px'
    const sourceHeader = () => {
        return <div style={{minHeight: useHeaderHeight}}>
            <p>{sourceLabel || 'Available Options'}</p>
            {searchSource && <InputText value={sourceSearch} onChange={(e) => setSourceSearch(e.target.value)}/>}
            </div>
    }
    const targetHeader = () => {
        return <div style={{minHeight: useHeaderHeight}}>
            <p>{targetLabel || 'Selected Options'}</p>
            {searchTarget && <InputText value={targetSearch} onChange={(e) => setTargetSearch(e.target.value)}/>}
            </div>

    }
    const useHeight = height ? (_.isNumber(height) ? `${height}px` : height) : '100px'
    return <>
        <PPickList dataKey={choiceValueKey} source={filter(source, 'source')} target={filter(target, 'target')} itemTemplate={itemTemplate}
                   onChange={onChangePick} showSourceControls={!sourceSearch && extraConfig.showSourceControls} showTargetControls={!targetSearch && extraConfig.showTargetControls}
                   // onMoveAllToTarget={e => onMove('target', e.value)} onMoveAllToSource={e => onMove('source', e.value)}
                    // onMoveToTarget={e => onMove('target', e.value)} onMoveToSource={e => onMove('source', e.value)}
                   filterBy={'filter_label'} sourceFilterPlaceholder={'Search by name'} targetFilterPlaceholder={'Search by name'}
                   sourceHeader={sourceHeader()} targetHeader={targetHeader()}
        {...extract({style:undefined,className:undefined, sourceStyle: {height: useHeight}, targetStyle:{height: useHeight}}, extraConfig)}
        />

        </>
}

export default PickList
